export default __webpack_public_path__ + "static/salondeals-logo-verlenging-FR~WABANxpF-5a033818d7d324d4ab90c39e5994c79b.png";